var FORMITEM_LAYOUT_VARIANTS = {
  DEFAULT: 'variant-default',
  FOCUS: 'variant-focus',
  ACTIVE: 'variant-active',
  DISABLED: 'variant-disabled',
  READ_ONLY: 'variant-read-only',
  OPTIONAL: 'variant-optional'
};

export { FORMITEM_LAYOUT_VARIANTS };
//# sourceMappingURL=variants.js.map
